import { render, staticRenderFns } from "./MonorepoOverview.vue?vue&type=template&id=d52aa732&scoped=true"
import script from "./MonorepoOverview.vue?vue&type=script&lang=ts"
export * from "./MonorepoOverview.vue?vue&type=script&lang=ts"
import style0 from "./MonorepoOverview.vue?vue&type=style&index=0&id=d52aa732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52aa732",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,RepoCard: require('/app/components/AddRepo/RepoCard.vue').default,ZPagination: require('/app/components/zeal/ZPagination/ZPagination.vue').default})
